import { Grid } from '@chakra-ui/react'
import { AlertCircle, Clock, CalendarClock, UserX } from 'lucide-react'
import type { HelpdeskDashboardStats } from '@/lib/services/helpdeskDashboardService'
import DashboardStatCard from './DashboardStatCard'

const ITEMS: {
  key: keyof HelpdeskDashboardStats
  label: string
  icon: typeof AlertCircle
  accent: string
  labelColor: string
  valueColor: string
  to?: string
}[] = [
  {
    key: 'unresolved',
    label: 'Unresolved',
    icon: AlertCircle,
    accent: 'blue.400',
    labelColor: 'blue.700',
    valueColor: 'blue.900',
    to: '/tickets',
  },
  {
    key: 'overdue',
    label: 'Overdue',
    icon: Clock,
    accent: 'red.400',
    labelColor: 'red.700',
    valueColor: 'red.800',
    to: '/tickets',
  },
  {
    key: 'due_today',
    label: 'Due today',
    icon: CalendarClock,
    accent: 'orange.400',
    labelColor: 'orange.700',
    valueColor: 'orange.900',
    to: '/tickets',
  },
  {
    key: 'unassigned',
    label: 'Unassigned',
    icon: UserX,
    accent: 'yellow.400',
    labelColor: 'yellow.800',
    valueColor: 'yellow.900',
    to: '/tickets',
  },
]

type Props = {
  stats: HelpdeskDashboardStats
  loading?: boolean
}

export default function TicketQueueStrip({ stats, loading }: Props) {
  return (
    <Grid
      templateColumns={{ base: '1fr 1fr', lg: 'repeat(4, 1fr)' }}
      gap={2.5}
      w="100%"
      minW={0}
    >
      {ITEMS.map(({ key, label, icon: Icon, accent, labelColor, valueColor, to }) => (
        <DashboardStatCard
          key={key}
          label={label}
          value={(stats[key] as number) ?? 0}
          loading={loading}
          labelColor={labelColor}
          valueColor={valueColor}
          accent={accent}
          to={to}
          icon={<Icon size={16} strokeWidth={2} />}
        />
      ))}
    </Grid>
  )
}
